import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from '../../redux/connect';
import { changeLocationAction, fetchIssuesAction, deselectPushpinsAction } from '../../redux/actions';
import {
  getCurrentUser,
  getCurrentDocument,
  getFetchParams,
  getIssuesCollectionLoading,
  getIssuesCollectionError,
  getSortedIssuesFilteredBySheetsInDocument,
  getPushpinWorkflowEnabled,
} from '../../redux/selectors';
import { isNullOrUndefined, Button } from '@adsk/bim360-matrix-react-components';
import { issuesFetchParamsType, issueWrapperArrayType, userType } from '../../constants/proptype-validation';
import IssuesList from './components/IssuesList';
import IssuesPanelHeader from './components/IssuesPanelHeader/IssuesPanelHeader';
import IssueFetchError from '../../components/IssueFetchError';
import { canAdd } from '../../utils/issues-helpers';
import T from 'i18n-react';
import { documentType } from '../../constants/proptype-validation/issue-proptypes';
import featureFlags, { FEATURE_FLAGS } from '../../utils/featureFlags';
import lodashGet from 'lodash/get';
import { MaintenanceMessage } from '../../app/components/MaintenanceMode';

export class PureIssuesPanel extends PureComponent {
  constructor(...args) {
    super(...args);

    this.handleCreate = this.handleCreate.bind(this);
    this.handleClickRFI = this.handleClickRFI.bind(this);
  }
  componentWillMount() {
    this._initializeCurrentUserPermissions(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.currentUser !== nextProps.currentUser) {
      this._initializeCurrentUserPermissions(nextProps);
    }
  }

  componentDidUpdate(prevProps) {
    const { fetchParams, fetchIssuesAction } = this.props;
    if (prevProps.fetchParams !== fetchParams) {
      fetchIssuesAction();
    }
  }

  _initializeCurrentUserPermissions() {
    this._canUserAddIssue = null;
  }

  canUserAddIssue() {
    if (this._canUserAddIssue === null) {
      const { currentUser } = this.props;
      this._canUserAddIssue = canAdd(currentUser);
    }
    return this._canUserAddIssue;
  }

  renderList(issues) {
    const { loading } = this.props;

    return (
      <IssuesList issues={issues}
        loading={loading}
        onRFIClick={this.handleClickRFI}
      />
    );
  }

  handleClickRFI(id) {
    const { changeLocationAction, onRFIClick } = this.props;

    onRFIClick && onRFIClick(id);
    changeLocationAction(`/rfis/${id}`);
  }

  handleCreate() {
    const { handleCreateClick, changeLocationAction } = this.props;

    handleCreateClick && handleCreateClick();
    changeLocationAction('/rfis/new');
  }

  renderFooter() {
    const { pushpinWorkflowEnabled, document } = this.props;
    const isViewingDocumentLatestVersion = !isNullOrUndefined(document.latestVersion) && document.latestVersion !== document.version;

    return (
      <div className="IssuesPanel__toolbar">
        <Button
          className="IssuesPanel__create-button"
          styleType={Button.StyleType.PRIMARY}
          onClick={this.handleCreate}
          disabled={isViewingDocumentLatestVersion || !pushpinWorkflowEnabled || !this.canUserAddIssue()}
        >
          {T.translate('navigation.create')}
        </Button>
      </div>
    );
  }

  render() {
    const { issues, loading, error, currentUser } = this.props;

    const webFF = featureFlags.get(FEATURE_FLAGS.MAINTENANCE_MODE);
    const backendFF = !!lodashGet(currentUser, 'attributes.maintenanceEndDate');

    const isMaintenanceMode = (() => {
      switch (webFF) {
        case 'OFF':
          return false;
        case 'ON':
          return true;
        case 'Backend':
          return backendFF;
        default:
          return false;
      }
    })();

    return (
      
      <div className="IssuesPanel">
        <IssuesPanelHeader />

        <IssueFetchError error={error} />
          {isMaintenanceMode
          ? <MaintenanceMessage />
          : (
            <React.Fragment>
              <div className="IssuesPanel__list-animation-container">
                {issues.length > 0 || loading
                  ? this.renderList(issues)
                  : <p className="IssuesPanel__empty">{T.translate('none')}</p>
                }
              </div>
              {this.renderFooter()}
            </React.Fragment>
          )}
    
      </div>
    );
  }
}

PureIssuesPanel.displayName = 'IssuesPanel';

PureIssuesPanel.propTypes = {
  loading: PropTypes.bool.isRequired,
  error: PropTypes.bool,
  issues: issueWrapperArrayType.isRequired,
  currentUser: userType,
  fetchParams: issuesFetchParamsType.isRequired,
  fetchIssuesAction: PropTypes.func.isRequired,
  changeLocationAction: PropTypes.func.isRequired,
  deselectPushpinsAction: PropTypes.func.isRequired,
  pushpinWorkflowEnabled: PropTypes.bool.isRequired,
  document: documentType.isRequired,
  handleCreateClick: PropTypes.func,
  onRFIClick: PropTypes.func,
};

const mapStateToProps = state => ({
  fetchParams: getFetchParams(state),
  document: getCurrentDocument(state),
  loading: getIssuesCollectionLoading(state),
  error: getIssuesCollectionError(state),
  issues: getSortedIssuesFilteredBySheetsInDocument(state),
  pushpinWorkflowEnabled: getPushpinWorkflowEnabled(state),
  currentUser: getCurrentUser(state),
});

export default connect(mapStateToProps, {
  changeLocationAction,
  fetchIssuesAction,
  deselectPushpinsAction,
})(PureIssuesPanel);
